import jwt_decode from "jwt-decode";
import {
  authorization_endpoint,
  token_endpoint,
  client_id,
  //client_secret,
  redirectState,
  redirect_uri,
  tokenScope
} from "@/UrlService.js"

//pkcf generator
import {
  getChallenge,
  removeChallenge
} from "@/router/pkceCode.js"

import axios from 'axios';
//Used to get roles
import {axiosInstance} from "@/components/auth/AxiosInterceptor"

  /*Remove token and roles*/
  export function logout(state) {

    deleteAccessToken()
    deleteRefreshToken()
    //localStorage.removeItem("id_token")
    localStorage.removeItem('roles');

    //Generate pkce code. In localStorage there will be code_challenge, code_verifier
    const challengeCode = getChallenge();
    
    /*Remove this when in AWS
    if(state !== null && state !== undefined){
      window.location.replace(authorization_endpoint + "&state=" + state);
    }else{
      window.location.replace(authorization_endpoint);
    } 
    */

    /*Azure authorization*/
    const redirectUrl =
      authorization_endpoint + "?"+
      "client_id=" + client_id + "&" +
      "response_type=code&" +
      "redirect_uri=" + encodeURI(redirect_uri()) + "&" +
      "response_mode=query&" +
      "scope=openid&" +
      "code_challenge=" + challengeCode.code_challenge + "&"+
      "code_challenge_method=S256" + "&" +
      "state=" + state;
     
    window.location.replace(redirectUrl);
    
  }

  export const isTokenValid = async () => { 

    var access_token = getAccessToken()
    var refresh_token = getRefreshToken()

    //If both access and refresh exist
    if(access_token !== null && refresh_token !== null){
      
      var token = null;
      try{
        token = jwt_decode(access_token);
      }catch(error){
        return false
      }

      const dateExp = new Date(0); 
      dateExp.setUTCSeconds(token["exp"]);
      var dateExpNumber = dateExp.valueOf();
      
      //Check if expired.
      var actualDate =  new Date().valueOf();
      if(dateExpNumber <= actualDate){ //If expired try to refresh
        
        //Use refresh_token to get access token
        console.log("Access token expired. Try with refresh token")
        var new_access_token = await getAccessTokenFromRefreshToken(refresh_token)       
        console.log("Refresh token complete")
        return new_access_token;

      }else{//Not expired and valid token
        return access_token;
      }
    }else{// Refresh token or token are null
      logout(redirectState())
    }
  }

  //Redeem token from code. Used only in Nikita Portal APP
  export const getTokenFromCode = async  (code) => {

    // Line breaks for legibility only
    /*
    POST /{tenant}/oauth2/v2.0/token HTTP/1.1
    Host: https://login.microsoftonline.com
    Content-Type: application/x-www-form-urlencoded
    */
    var code_verifier = localStorage.getItem("code_verifier")

    const reqBody = new URLSearchParams();
    reqBody.append('grant_type', 'authorization_code');
    reqBody.append('code', code);
    //Add AZURE parameters
    reqBody.append('redirect_uri', encodeURI(redirect_uri()));
    reqBody.append('code_verifier', code_verifier);
    reqBody.append('client_id', client_id);
    reqBody.append('scope', tokenScope);

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      /*auth: {
        username: client_id,
        password: client_secret
      }*/
    }

    const sendPostRequest = async () => {
      try {
          const resp = await axios.post(token_endpoint, reqBody, config);
          return resp.data
      } catch (err) {
          // Handle Error Here
          console.error(err.response.data);
          return false
      }
    };

    //Send request
    var response = await sendPostRequest();

    if(response === false){
      return false;
    }

    //Store all tokens into local storage
    saveAccessToken(response["access_token"])
    saveRefreshToken(response["refresh_token"])
    //localStorage.setItem('id_token', response["id_token"])
    saveApiScope(response["scope"])
    saveClientId(client_id)
    saveTokenEndpoint(token_endpoint)
 
    //Remove code challenge and verifier
    removeChallenge()
    
    return true
  }

  //Get access token from refresh_token
  export const getAccessTokenFromRefreshToken = async (refresh_token) => {

    // Line breaks for legibility only
    /*
    POST /{tenant}/oauth2/v2.0/token HTTP/1.1
    Host: https://login.microsoftonline.com
    Content-Type: application/x-www-form-urlencoded
    */

    const reqBody = new URLSearchParams();
    reqBody.append('grant_type', 'refresh_token');
    reqBody.append('refresh_token', refresh_token);
    //Add params for AZURE
    reqBody.append('client_id', client_id);
    reqBody.append('scope', tokenScope);
    
    //Header confgiuration
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      /*auth: {
        username: client_id,
        password: client_secret
      }*/
    }

    const sendPostRequest = async () => {
      try {
          const resp = await axios.post(token_endpoint, reqBody, config);
          return resp.data
      } catch (err) {
          // Handle Error Here
          console.error(err.response.data);
          return false
      }
    };

    //Get new token
    var response = await sendPostRequest();

    //Problems with refresh token. 
    if(response === false){
      logout(redirectState())
    }
    
    //Store all tokens ino local storage
    saveAccessToken(response["access_token"])
    saveRefreshToken(response["refresh_token"])
    //localStorage.setItem('id_token', response["id_token"])
    saveApiScope(response["scope"])
    saveClientId(client_id)
    saveTokenEndpoint(token_endpoint)

    return response["access_token"];
  }

//Get roles
export async function getRoles(url){
  
  try{
    var response = await axiosInstance.get(url)
    localStorage.setItem('roles', btoa(JSON.stringify(response.data)));
    return true;
  }catch(error){
    console.log("roles stored error")
    console.log(JSON.stringify(error))
    return error;
  }
}

//Get all roles from local storage
export function getRolesFromToken(){
  try{
    return JSON.parse(atob(localStorage.getItem("roles")));
  } catch(e){
    return [];
  }
}

//Find if this role exists among roles 
export function roleCheck(role){
  var roles = getRolesFromToken();
  return roles.find(elem => elem == role) ? true : false;
}

export const getAccessToken = () => {
  var access_token = localStorage.getItem('access_token')
  if(access_token !== null){
    return atob(access_token);
  }else{
    console.log("eccess token not found")
    return null
  }  
}

export const saveAccessToken = (access_token) => {
  localStorage.setItem('access_token', btoa(access_token))
}

export const deleteAccessToken = () => {
  localStorage.removeItem('access_token')
}

export const getRefreshToken = () => {
  var refresh_token = localStorage.getItem('refresh_token')
  if(refresh_token !== null){
    return atob(refresh_token);
  }else{
    console.log("refresh token not found")
    return null
  }
} 

export const saveRefreshToken = (refresh_token) => {
  localStorage.setItem('refresh_token', btoa(refresh_token))
}  

export const deleteRefreshToken = () => {
  localStorage.removeItem('refresh_token')
} 

export const saveApiScope = (scope) => {
  localStorage.setItem('scope', btoa(scope))
}

export const saveClientId = (client_id) => {
  localStorage.setItem('client_id', btoa(client_id))
}

export const saveTokenEndpoint = (token_endpoint) => {
  localStorage.setItem('token_endpoint', btoa(token_endpoint))
}